<template>
  <div v-if="notification.is_check === 0">
    <v-dialog
      v-model="dialog" :max-width="maxWidth"
      @click:outside="exitNotification(notification.id)"
      @keydown.esc="exitNotification(notification.id)">
      <v-card>
        <v-card-title v-text="notification.title"></v-card-title>
        <v-card-text v-text="notification.message"></v-card-text>
        <v-card-text>
          <v-img v-if="notification.image_url" :src="notification.image_url" contain></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import EventBus from '../../../misc/eventbus';

export default {
  name: 'NotificationsDialog',
  props: ['notification', 'maxWidth'],
  data: () => ({ dialog: false }),
  created() {
    EventBus.$on('setNotificationState', this.setState);
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    exitNotification(id) {
      this.send({ route: 'notification/modal/set', data: { notification_modal_id: id } });
    },
    setState() {
      this.dialog = !this.dialog;
    },
  },
};
</script>
